import {
  MdRefresh,
  MdArrowForward,
  MdArrowBack,
  MdFolderOpen } from
'react-icons/md';
import { useState } from 'react';
import { RiLoader4Line } from 'react-icons/ri';
import FileList from './FileList';
import { parseHostInput } from '../utils/connection';
import { localParent } from '../utils/paths';

const TransferView = ({
  transferSplit,
  setTransferSplit,
  transferLeftPath,
  transferRightPath,
  connection,
  transferConnecting,
  transferConnected,
  handleTransferConnect,
  refreshTransferSide,
  moveBetween,
  transferLeftSelected,
  transferRightSelected,
  setTransferLeftSelected,
  setTransferRightSelected,
  transferLeftEntries,
  transferRightEntries,
  transferRight,
  setTransferRight,
  listContainerStyle,
  visibleTransferLeftEntries,
  visibleTransferRightEntries,
  showCheckboxes,
  remoteParent,
  onNavigateTransfer,
  canUseLocalFs = true,
  transferStatusMap,
  transferring = false,
  transferOverlaySide = null,
  transferProgress = null,
  transferLoadingPath = { left: null, right: null },
  transferRefreshing = { left: false, right: false },
  transferAllFromOther,
  transferIfExists = 'replace',
  setTransferIfExists,
  handleTransferDisconnect,
  transferDisconnectDisabled = false,
  leftConnectingOverlay = false,
  mobilePanelTab = 'other',
  isMobileLayout = false,
}) => {
  const [mobileWarningDismissed, setMobileWarningDismissed] = useState(false);

  if (!transferRight) {
    return <div className="p-4 text-red-400">Error: transferRight prop is missing</div>;
  }
  const handleSelect = (side, entry, meta = {}) => {
    const setSelected = side === 'left' ? setTransferLeftSelected : setTransferRightSelected;
    setSelected((prev) => {
      const next = new Set(meta.ctrlKey ? prev : []);
      if (next.has(entry.path) && meta.ctrlKey) {
        next.delete(entry.path);
      } else {
        next.add(entry.path);
      }
      return next;
    });
  };

  const handleToggle = (side, entry, checked) => {
    const setSelected = side === 'left' ? setTransferLeftSelected : setTransferRightSelected;
    setSelected((prev) => {
      const next = new Set(prev);
      if (checked) {
        next.add(entry.path);
      } else {
        next.delete(entry.path);
      }
      return next;
    });
  };
  const handleOpen = (side, entry) => {
    if (!entry || entry.type !== 'dir') return;
    if (!onNavigateTransfer) return;
    onNavigateTransfer(side, entry.path);
  };

  const handleUp = (side) => {
    if (!onNavigateTransfer) return;
    if (side === 'left') {
      const next = remoteParent ? remoteParent(transferLeftPath) : '/';
      onNavigateTransfer('left', next || '/');
      return;
    }
    if (transferRight?.mode === 'local') {
      const basePath = transferRightPath || transferRight?.localPath || '';
      const next = localParent(basePath);
      if (!next && !basePath) return;
      onNavigateTransfer('right', next || basePath);
      return;
    }
    const next = remoteParent ? remoteParent(transferRightPath) : '/';
    onNavigateTransfer('right', next || '/');
  };
  const progressPct = transferProgress?.total > 0
    ? Math.round((transferProgress.current / transferProgress.total) * 100)
    : 0;
  const TransferDirectionIcon = transferOverlaySide === 'left' ? MdArrowBack : MdArrowForward;

  return (
    <div className="flex-1 min-h-0 flex flex-col gap-2">
      {isMobileLayout && !mobileWarningDismissed &&
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur">
          <div className="glass-panel w-full max-w-sm rounded-2xl p-6 flex flex-col gap-4">
            <h3 className="text-base font-semibold text-white">Transfer tool on mobile</h3>
            <p className="text-sm text-textMuted">The transfer tool works best on desktop. Some features may not work correctly on mobile or tablet.</p>
            <button type="button" className="pill-button w-full justify-center py-2" onClick={() => setMobileWarningDismissed(true)}>Got it</button>
          </div>
        </div>
      }
      {transferring && transferProgress &&
        <div className="rounded-xl border border-border/60 bg-inset/40 px-4 py-2 flex flex-col gap-1">
          <div className="flex items-center justify-between text-xs text-textMuted">
            <span className="font-semibold text-accent">
              {transferProgress.total === 0
                ? 'Collecting files...'
                : `Transferring ${transferProgress.current} of ${transferProgress.total} files`}
            </span>
            {transferProgress.total > 0 && <span>{progressPct}%</span>}
          </div>
          {transferProgress.total > 0 &&
            <div className="h-1.5 w-full overflow-hidden rounded-full bg-border/50">
              <div
                className="h-full bg-accent transition-all duration-300"
                style={{ width: `${progressPct}%` }} />
            </div>
          }
        </div>
      }
    <div className="flex-1 min-h-0 flex flex-col lg:flex-row gap-2">

      <section
        data-sherman="transfer-other"
        className="glass-panel rounded-2xl p-4 flex flex-col min-h-0 flex-1"
        style={isMobileLayout ? { flex: 1, display: mobilePanelTab !== 'other' ? 'none' : '' } : { flexBasis: `${(1 - transferSplit) * 100}%`, minWidth: '28%' }}>

        <div className="flex flex-col gap-3 flex-1 min-h-0 overflow-y-auto">
          <div className="flex items-center justify-between">
            <p className="text-sm font-semibold text-textMuted">Other Server</p>
            {transferConnected &&
              <button type="button" className="panel-button p-2.5" onClick={() => refreshTransferSide('right')}>
                <MdRefresh className={`text-2xl${transferRefreshing.right ? ' spin-fast' : ''}`} />
              </button>
            }
          </div>

          {!transferConnected ?
            <div className="rounded-xl border border-dashed border-border/60 bg-inset/20 p-4 flex flex-col gap-3">
              <div className="flex flex-col gap-3">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="text-sm text-textMuted ml-1">Protocol</label>
                      <select
                        className="w-full mt-1 rounded-lg border border-border bg-inset/60 px-3 py-2.5 text-base text-white focus:border-accent focus:outline-none"
                        value={transferRight.config.protocol}
                        onChange={(e) => setTransferRight({ ...transferRight, config: { ...transferRight.config, protocol: e.target.value } })}>
                        <option value="sftp">SFTP</option>
                        <option value="ftps">FTPS</option>
                      </select>
                    </div>
                    <div>
                      <label className="text-sm text-textMuted ml-1">Port</label>
                      <input
                        type="number"
                        className="w-full mt-1 rounded-lg border border-border bg-inset/60 px-3 py-2.5 text-base text-white focus:border-accent focus:outline-none"
                        value={transferRight.config.port}
                        onChange={(e) => setTransferRight({ ...transferRight, config: { ...transferRight.config, port: e.target.value } })} />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="text-sm text-textMuted ml-1">Host</label>
                      <input
                        type="text"
                        className="w-full mt-1 rounded-lg border border-border bg-inset/60 px-3 py-2.5 text-base text-white focus:border-accent focus:outline-none"
                        value={transferRight.config.host}
                        onChange={(e) => {
                          const raw = e.target.value;
                          const parsed = parseHostInput(raw, transferRight.config.protocol);
                          setTransferRight({ ...transferRight, config: { ...transferRight.config, host: parsed.host || raw, protocol: parsed.host ? parsed.protocol : transferRight.config.protocol, port: parsed.port ?? transferRight.config.port } });
                        }}
                        onBlur={(e) => {
                          const raw = e.target.value;
                          const parsed = parseHostInput(raw, transferRight.config.protocol);
                          if (!parsed.host) return;
                          setTransferRight({ ...transferRight, config: { ...transferRight.config, host: parsed.host, protocol: parsed.protocol, port: parsed.port ?? transferRight.config.port } });
                        }}
                        placeholder="127.0.0.1" />
                    </div>
                    <div>
                      <label className="text-sm text-textMuted ml-1">Username</label>
                      <input
                        type="text"
                        className="w-full mt-1 rounded-lg border border-border bg-inset/60 px-3 py-2.5 text-base text-white focus:border-accent focus:outline-none"
                        value={transferRight.config.username}
                        onChange={(e) => setTransferRight({ ...transferRight, config: { ...transferRight.config, username: e.target.value } })} />
                    </div>
                  </div>
                  <div>
                    <label className="text-sm text-textMuted ml-1">Password</label>
                    <input
                      type="password"
                      className="w-full mt-1 rounded-lg border border-border bg-inset/60 px-3 py-2.5 text-base text-white focus:border-accent focus:outline-none"
                      value={transferRight.config.password}
                      onChange={(e) => setTransferRight({ ...transferRight, config: { ...transferRight.config, password: e.target.value } })} />
                  </div>
                  {connection && transferRight.config.host &&
                    transferRight.config.host === connection.host &&
                    String(transferRight.config.port) === String(connection.port) &&
                    transferRight.config.username === connection.username &&
                    <p className="rounded-lg border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-sm text-amber-300">
                      This looks like the same server you are already connected to. Please enter a different server.
                    </p>
                  }
                  <button type="button" className="pill-button w-full justify-center py-2.5 text-base flex items-center gap-2" onClick={() => handleTransferConnect()} disabled={transferConnecting}>
                    {transferConnecting ? <><RiLoader4Line className="animate-spin" /> Connecting...</> : 'Connect'}
                  </button>
                </div>
            </div> :

            <div className="flex items-center justify-between">
              <p className="text-base text-textPrimary/80 break-all">{transferRightPath || '/'}</p>
              <button
                className="ghost-button text-sm disabled:cursor-not-allowed disabled:opacity-50"
                onClick={handleTransferDisconnect}
                disabled={transferDisconnectDisabled}
                title={transferDisconnectDisabled ? 'Transfers are still running' : 'Disconnect'}>
                Disconnect
              </button>
            </div>
          }
        </div>

        {transferConnected &&
          <div className="mt-3 rounded-xl border border-border/60 bg-inset/30 px-3 py-2 flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-textMuted">Existing files</span>
            <select
              className="rounded-lg border border-border bg-inset/60 px-3 py-2 text-sm text-white focus:border-accent focus:outline-none"
              value={transferIfExists}
              onChange={(e) => setTransferIfExists?.(e.target.value)}
              disabled={transferring}>
              <option value="replace">Overwrite</option>
              <option value="skip">Skip</option>
            </select>
          </div>
        }

        {transferConnected && !transferring && transferAllFromOther &&
          <button
            data-sherman="transfer-all"
            type="button"
            className="pill-button w-full justify-center py-3 text-base font-semibold flex items-center gap-2 mt-3"
            onClick={transferAllFromOther}>
            Transfer All
          </button>
        }

        {transferConnected &&
          <div data-sherman="transfer-files-other" className="relative mt-3 flex-1 min-h-0 bg-inset/40 rounded-xl overflow-hidden flex flex-col">
            {transferring && transferOverlaySide === 'right' &&
              <div className="absolute inset-0 z-10 bg-black/40 flex items-center justify-center rounded-xl">
                <span className="text-sm font-semibold text-white/70">Transfer in progress</span>
              </div>
            }
            <FileList
              entries={visibleTransferRightEntries || []}
              onOpen={transferring ? () => {} : (entry) => handleOpen('right', entry)}
              onSelect={transferring ? () => {} : (entry, meta) => handleSelect('right', entry, meta)}
              selectedSet={transferRightSelected}
              onToggleSelect={transferring ? () => {} : (entry, checked) => handleToggle('right', entry, checked)}
              side={transferRight.mode === 'local' ? 'local' : 'remote'}
              currentPath={transferRightPath}
              onUp={transferring ? undefined : () => handleUp('right')}
              showCheckboxes
              statusMap={transferStatusMap}
              loadingPath={transferLoadingPath.right}
              loadingUp={transferLoadingPath.right === (remoteParent ? remoteParent(transferRightPath) : '/')}
              onPageChange={transferring ? undefined : (page) => onNavigateTransfer?.('right', transferRightPath, { page })}
              paginationDisabled={transferring || Boolean(transferLoadingPath.right)} />
          </div>
        }
        {isMobileLayout && transferConnected && !transferring &&
          <div className="flex gap-2 pt-2 shrink-0">
            <button
              type="button"
              className="flex-1 panel-button py-2.5 text-accent flex items-center justify-center gap-2"
              onClick={() => moveBetween('right')}
              disabled={transferLeftSelected.size === 0}>
              <MdArrowBack className="text-lg" /> Copy to Other
            </button>
            <button
              type="button"
              className="flex-1 panel-button py-2.5 text-accent flex items-center justify-center gap-2"
              onClick={() => moveBetween('left')}
              disabled={transferRightSelected.size === 0}>
              Copy to Host <MdArrowForward className="text-lg" />
            </button>
          </div>
        }
      </section>

      <div className="flex lg:flex-col items-center justify-center gap-2 p-1" style={{ display: isMobileLayout ? 'none' : '' }}>
        {transferring ?
          <div className="flex items-center gap-1 text-accent">
            <TransferDirectionIcon className="text-xl animate-pulse" />
            <TransferDirectionIcon className="text-lg animate-pulse opacity-60" style={{ animationDelay: '150ms' }} />
            <TransferDirectionIcon className="text-base animate-pulse opacity-30" style={{ animationDelay: '300ms' }} />
          </div> :
          <div data-sherman="transfer-copy" className="flex lg:flex-col gap-2">
            <button
              type="button"
              className="panel-button px-4 py-2.5 text-accent flex items-center gap-2 text-base"
              onClick={() => moveBetween('right')}
              title="Copy selected to Other Server"
              disabled={transferLeftSelected.size === 0}>
              <MdArrowBack className="text-lg shrink-0" />
              <span className="hidden lg:inline">Copy</span>
            </button>
            <button
              type="button"
              className="panel-button px-4 py-2.5 text-accent flex items-center gap-2 text-base"
              onClick={() => moveBetween('left')}
              title="Copy selected to Current Session"
              disabled={transferRightSelected.size === 0}>
              <span className="hidden lg:inline">Copy</span>
              <MdArrowForward className="text-lg shrink-0" />
            </button>
          </div>
        }
      </div>

      <section
        data-sherman="transfer-current"
        className="glass-panel rounded-2xl p-4 flex flex-col min-h-0 flex-1"
        style={isMobileLayout ? { flex: 1, display: mobilePanelTab !== 'host' ? 'none' : '' } : { flexBasis: `${transferSplit * 100}%`, minWidth: '28%' }}>

        <div className="flex items-start justify-between gap-3">
          <div className="space-y-1">
            <p className="text-sm font-semibold text-textMuted">Current Session</p>
            <p className="text-base text-textPrimary/80 break-all">{transferLeftPath || '/'}</p>
          </div>
          <button type="button" className="panel-button p-2.5" onClick={() => refreshTransferSide('left')} title="Refresh">
            <MdRefresh className={`text-2xl${transferRefreshing.left ? ' spin-fast' : ''}`} />
          </button>
        </div>
        <div className="relative mt-4 flex-1 min-h-0 bg-inset/40 rounded-xl overflow-hidden flex flex-col">
          {leftConnectingOverlay &&
            <div className="absolute inset-0 z-20 bg-black/40 flex flex-col items-center justify-center gap-3 rounded-xl">
              <RiLoader4Line className="text-accent text-3xl animate-spin" />
              <span className="text-sm font-semibold text-white/70">Connecting...</span>
            </div>
          }
          {transferring && transferOverlaySide === 'left' &&
            <div className="absolute inset-0 z-10 bg-black/40 flex items-center justify-center rounded-xl">
              <span className="text-sm font-semibold text-white/70">Transfer in progress</span>
            </div>
          }
          <FileList
            entries={visibleTransferLeftEntries || []}
            onOpen={transferring ? () => {} : (entry) => handleOpen('left', entry)}
            onSelect={transferring ? () => {} : (entry, meta) => handleSelect('left', entry, meta)}
            selectedSet={transferLeftSelected}
            onToggleSelect={transferring ? () => {} : (entry, checked) => handleToggle('left', entry, checked)}
            side="remote"
            currentPath={transferLeftPath}
            onUp={transferring ? undefined : () => handleUp('left')}
            showCheckboxes
            loadingPath={transferLoadingPath.left}
            loadingUp={transferLoadingPath.left === (remoteParent ? remoteParent(transferLeftPath) : '/')}
            onPageChange={transferring ? undefined : (page) => onNavigateTransfer?.('left', transferLeftPath, { page })}
            paginationDisabled={transferring || Boolean(transferLoadingPath.left)} />
        </div>
      </section>
    </div>
    </div>);

};

export default TransferView;
